import { emailTemplateApi, emailTemplateCategoryApi } from 'app/services/api';

import { INCLUDE_OPTIONS_MAP, UPDATE_TEMPLATE_TYPES_MAP } from 'constants/emailTemplates';
import { catchAsyncActionError } from 'utils/action';
import { mapTemplateVariables } from 'utils/emailTemplate';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { addTemplateVariablesToDynamicFieldsAction } from 'store/forms/actions';

export const EMAIL_TEMPLATES_TYPE = createNamedActions('emailTemplates', {
  GET_EMAIL_TEMPLATES: 'GET_EMAIL_TEMPLATES',
  GET_EMAIL_TEMPLATE_BY_ID: 'GET_EMAIL_TEMPLATE_BY_ID',
  ADD_EMAIL_TEMPLATE: 'ADD_EMAIL_TEMPLATE',
  UPDATE_EMAIL_TEMPLATE: 'UPDATE_EMAIL_TEMPLATE',
  UPDATE_EMAIL_TEMPLATE_INFO: 'UPDATE_EMAIL_TEMPLATE_INFO',
  DELETE_EMAIL_TEMPLATE: 'DELETE_EMAIL_TEMPLATE',
});

export const getEmailTemplateByIdAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await emailTemplateApi.getTemplate({
    ...params,
    include: INCLUDE_OPTIONS_MAP.TEMPLATE_CONTENT,
  });
  const templateVariables = mapTemplateVariables(data.variables);

  dispatch(addTemplateVariablesToDynamicFieldsAction(templateVariables));

  return dispatch({
    type: EMAIL_TEMPLATES_TYPE.GET_EMAIL_TEMPLATE_BY_ID,
    payload: data,
  });
});

export const addEmailTemplateAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await emailTemplateApi.createTemplate(params);

  return dispatch({
    type: EMAIL_TEMPLATES_TYPE.ADD_EMAIL_TEMPLATE,
    payload: data,
  });
});

// change template content
export const updateEmailTemplateAction = catchAsyncActionError(
  ({ templateId, categoryId, htmlTemplate, metadata }) =>
    async dispatch => {
      const { data } = await emailTemplateApi.editTemplate({
        templateId,
        categoryId,
        body: {
          templateId,
          templateContent: {
            hasMetadata: true,
            metadata,
            template: {
              value: htmlTemplate,
            },
          },
          type: UPDATE_TEMPLATE_TYPES_MAP.CONTENT,
        },
      });

      return dispatch({
        type: EMAIL_TEMPLATES_TYPE.UPDATE_EMAIL_TEMPLATE,
        payload: data,
      });
    },
);

// change group or name
export const updateEmailTemplateInfoAction = catchAsyncActionError(
  ({ templateId, name, subject, categoryId, newCategoryId }) =>
    async dispatch => {
      const { data } = await emailTemplateApi.editTemplate({
        templateId,
        categoryId,
        body: {
          name,
          templateSubject: subject,
          templateId,
          type: subject
            ? UPDATE_TEMPLATE_TYPES_MAP.SUBJECT
            : UPDATE_TEMPLATE_TYPES_MAP.CATEGORY_AND_NAME,
          ...(!subject && { categoryId: newCategoryId }),
        },
      });

      return dispatch({
        type: EMAIL_TEMPLATES_TYPE.UPDATE_EMAIL_TEMPLATE_INFO,
        payload: data,
      });
    },
);

export const deleteEmailTemplateAction = catchAsyncActionError(params => async dispatch => {
  await emailTemplateApi.deleteTemplate(params);

  return dispatch({
    type: EMAIL_TEMPLATES_TYPE.DELETE_EMAIL_TEMPLATE,
    payload: params.emailTemplateId,
  });
});

export const getEmailTemplatePreviewActionV2 = catchAsyncActionError(
  params => async () => await emailTemplateCategoryApi.getPreviewV2(params),
);

export const uploadEmailTemplateFileAction = catchAsyncActionError(
  params => async () => await emailTemplateApi.uploadFile(params),
);
